import React from 'react';
import { Row } from 'react-flexbox-grid';
import { Checkbox } from 'antd';
import tick from '../../../assets/Tick.png';
import  { EXCLUDED_ASSET_GROUPS } from 'utils/ExcludedAssetsConstants';

const ipscss = {
    marginLeft: '0px',
    marginRight: '0px'
}
const PreFormExceptionAssetMapping = (props) => {
    const { asset, selected, formId, currentFormId, onChangeAssetId, saveVisibleText, preEFormMapping, setActive, setHeight, handleCheckboxSelect, exceptionId, editVisibleProps, checkBoxHidden } = props;

    const isExcludedGroup = EXCLUDED_ASSET_GROUPS.includes(asset.assetGroupName);

    return (

        <Row style={ipscss} className={`pre-status--row asset-table-header ${selected ? 'selected' : ''} `}>
            <div className="tasklist--checkbox">
                {!checkBoxHidden &&
                    <Checkbox
                        disabled={isExcludedGroup || editVisibleProps}
                        checked={selected}
                        onClick={() => handleCheckboxSelect(asset)}
                    />
                }
                {/* :
            <span className={"tick--signed"}><img src={tick} alt="Tick"/></span>}  */}
            </div>


            <div className="col-xs">
                {(asset.deleteFlag === 'P') ? <span style={{ color: 'red' }}>{asset.assetName}</span> :
                    (asset.deleteFlag === 'B') ? <b>{asset.assetName}</b> : asset.assetName}
            </div>
            <div className="col-xs" style={{ textAlign: "center" }}>
                {(asset.deleteFlag === 'P') ? <span style={{ color: 'red' }}>VERIFY IPS DATA</span> :
                    (asset.deleteFlag === 'B') ? <b>VERIFY IPS DATA</b> : asset.assetGroupName}
            </div>
            <div className="col-xs" style={{ textAlign: "center" }}>
                {asset.assetStatus}
            </div>

        </Row>
    )
}
export default PreFormExceptionAssetMapping;